import { BreakpointsPx, getImagesByDimension } from '@jsmdg/imgix';
import { type Image } from '../../shared/dyResponse';

export const enrichWithImgix = ({ alt, src }: { alt: string; src: string }): Image => {
    return {
        ...getImagesByDimension(src, {
            [BreakpointsPx.xs]: { width: 256, height: 169 },
            [BreakpointsPx.xl]: { width: 256, height: 169 },
        }),
        alt,
        url: src,
    } as Image;
};
